import { actions, reducer } from './reducer';
import * as sagas from './sagas';
import * as selectors from './selectors';

export const adminModel = { actions, reducer, selectors, sagas };
